import type { ReactNode } from "react";

export function EmptyState({
  icon,
  title,
  description,
  action,
}: { icon?: ReactNode; title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-border bg-surface py-14 text-center">
      {icon && <div className="mb-1 text-fg-dim">{icon}</div>}
      <div className="text-sm font-medium">{title}</div>
      {description && <div className="max-w-[320px] text-xs text-fg-muted">{description}</div>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
